import { TurnedTextFormatKinds } from "./TurnedTextFormatKinds";
import { ITurnedTextStyle } from "./ITurnedTextStyle";

export class TurnedTextStyle {
  constructor(
    public formatKind: TurnedTextFormatKinds,
  ) {
  }
  
  clone(): TurnedTextStyle {
    return new TurnedTextStyle(this.formatKind);
  }

  static from(source: ITurnedTextStyle): TurnedTextStyle {
    return new TurnedTextStyle(source.formatKind);
  }

  static to(source: TurnedTextStyle): ITurnedTextStyle {
    return {
      formatKind: source.formatKind,
    };
  }
}
